
import { ImportWizardDcrDrugListComponent } from './../import-wizard-dcr-drug-list/import-wizard-dcr-drug-list.component';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastService } from 'src/app/shared/services/toast.service';
import { DcrDrug } from '../../models/drug';
import { RpoToolService } from '../../services/rpo-tool.service';
import * as constants from 'src/app/config/app-constants';
import { Router } from '@angular/router';
import { routePaths } from 'src/app/config/app-constants';
import { EventEmitter, Output } from '@angular/core';
import { ImportWizardDrugClassificationResolutionComponent } from './../import-wizard-drug-classification-resolution/import-wizard-drug-classification-resolution.component';

@Component({
  selector: 'app-dcr-drug-list',
  standalone: false,
  templateUrl: './dcr-drug-list.component.html',
  styleUrl: './dcr-drug-list.component.scss'
})
export class DcrDrugListComponent implements OnInit {
  displayedColumns = ['name','strength', 'drugNumber', 'priority','dcrAge', 'status', 'caseNumber', 'caseOwner', 'caseSource', 'manufacturer','action'];
  selectedRow:any;
  @Output() countUpdated: EventEmitter<number> = new EventEmitter<number>();
  @Input() caseOwner: string = "All";

  dataSource= new MatTableDataSource<DcrDrug>();
     totalRows: number = 0;
     currentPage: number = 1;
     pageSize: number = 5;
     pageSizeOptions: number[] = [5, 10, 20, 40, 50];
     isCaseNoShow: boolean = false;
  constructor(
    private rpoService: RpoToolService,
    private dialog: MatDialog,
    private ngxLoader: NgxUiLoaderService,
    private route: Router,
    private toastService: ToastService,) { }

  ngOnInit(): void {
   this.getDrugData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['caseOwner'] && !changes['caseOwner'].firstChange) {
      this.onCaseOwnerChange();
    }
  }

  onCaseOwnerChange() {
    this.currentPage = 1; // Reset to first page when filter changes
    this.ngxLoader.start();
    this.getDrugData();
  }


  getDrugData(){
    this.rpoService.getDcrDrugs(
      this.currentPage,
      this.pageSize,
      this.caseOwner,
      '',
      ''
    ).subscribe((result)=>{
     this.ngxLoader.stop();

     this.dataSource.data = result.data.drugs
     this.currentPage = result.data.currentPage
     this.totalRows = result.data.totalRows
     this.countUpdated.emit(this.totalRows);

    },
    (error: HttpErrorResponse) => {
      this.toastService.openToast(
        error.message,
        constants.ToastPanelType.error,
        2
      );

    })
  }

  openImportWizardDcrDrug() {

    const dialogRef = this.dialog.open(ImportWizardDcrDrugListComponent, {
    backdropClass: ['lgDialog'],
    disableClose: true,
    data: {
      caseOwner: this.caseOwner
    }
    });

  }

  openImportWizardDcrDetails(caseNo:any) {
    const dialogRef = this.dialog.open(ImportWizardDrugClassificationResolutionComponent, {
      backdropClass: ['lgDialog'],
      disableClose: false,
      data: {
        caseNo: caseNo
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
        this.getDrugData();
    });

  }
}
